import { Reveal, Corners } from "./Bits";
import { SteamIcon, STEAM_URL } from "./SteamIcon";

export const SteamBand = () => (
  <section
    data-testid="steam-band"
    className="relative overflow-hidden border-t border-line bg-void px-6 py-20 md:px-12 md:py-28"
  >
    <div className="grid-bg absolute inset-0 opacity-30" />
    <div className="relative mx-auto max-w-[1400px]">
      <Reveal>
        <div className="clip-angle relative flex flex-col justify-between gap-10 border border-line bg-[#0D1117] p-10 md:flex-row md:items-center md:p-16">
          <Corners />
          <div>
            <p className="flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] text-slate-500">
              <span className="h-1.5 w-1.5 animate-pulse bg-signal" />
              FINAL DIRECTIVE // PRE-LAUNCH
            </p>
            <h2 className="mt-4 font-mono text-3xl font-extrabold uppercase tracking-tight text-[#F8FAFC] md:text-5xl">
              Join the operation
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-slate-400">
              Wishlist on Steam and the deployment order reaches you the second the window opens.
              No noise. One signal.
            </p>
          </div>
          <a
            data-testid="steam-wishlist-cta"
            href={STEAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-pulse clip-angle inline-flex shrink-0 items-center gap-3 border border-signal px-8 py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-signal transition-colors hover:bg-signal hover:text-[#0A0E12]"
          >
            <SteamIcon className="h-4 w-4" />
            Request deployment clearance // Wishlist
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
